import { render, staticRenderFns } from "./StaffInfo.vue?vue&type=template&id=e63208a2&scoped=true&"
import script from "./StaffInfo.vue?vue&type=script&lang=tsx&"
export * from "./StaffInfo.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e63208a2",
  null
  
)

export default component.exports